import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import moment from 'moment';

import { history } from '../../../../../helpers';
import { parentSupervisionActions } from '../../../../../store';
import { getUtcOffset } from '../../../../../utils/common';

import type { IParentSupervision } from '../../../../../utils/types';

interface UseSupervisionActionsParams {
  values: IParentSupervision | null;
  parentSupervision: IParentSupervision | null;
}

function useSupervisionActions({
  values,
  parentSupervision: _parentSupervision,
}: UseSupervisionActionsParams) {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const [submitting, setSubmitting] = useState(false);

  const handleStartNotes = useCallback(async () => {
    if (!values) return;

    setSubmitting(true);
    const startDate = moment(values.date_start ?? new Date())
      .seconds(0)
      .milliseconds(0);
    const data = {
      ...values,
      client_id: values.client?.id ?? null,
      goals_and_targets_adhered: false,
      date_start: startDate,
      utc_offset_date_start: getUtcOffset(startDate),
    };

    const response = await dispatch(
      parentSupervisionActions.startParentSupervision({ data, getAccessTokenSilently }),
    );
    setSubmitting(false);

    if (response?.payload?.id) {
      history.navigate(`/parent-supervisions/${response.payload.id}`);
    }
  }, [dispatch, getAccessTokenSilently, values]);

  return {
    submitting,
    handleStartNotes,
  };
}

export default useSupervisionActions;
